import React from "react";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import "twin.macro";

import MaterialOwnerSvg from "../../static/images/material-owners.svg";
import { Layout } from "../components/Layout/Layout";
import TheBigTrio from "../components/TheBigTrio";
import { getTranslationList } from "../utils/common";

const MaterialOwner: React.FC = () => {
  const { t } = useTranslation();

  const list = getTranslationList(t, "materialOwners.list");

  return (
    <Layout>
      <Helmet title={t("materialOwners.header")} />
      <TheBigTrio header="materialOwners.header" subheader="materialOwners.subheader" icon={<MaterialOwnerSvg tw="" />} list={list} />
    </Layout>
  );
};

export default MaterialOwner;
